import PropTypes from 'prop-types'
import ReceiptNo from './ReceiptNo'

/**
 * A surface on the desk: white, a 1px ink-hair edge, 8px corners, 24px of
 * padding (32px from sm). `title` prints a heading at the top; `no` prints a
 * record number in the top corner, only for a record the database numbers
 * in a stable sequence. `ruled` is accepted for older callers and ignored.
 */
export default function Sheet({
  as: Tag = 'section',
  no,
  title,
  children,
  className = '',
  bodyClassName = '',
  // eslint-disable-next-line no-unused-vars
  ruled,
  ...rest
}) {
  return (
    <Tag
      className={`bg-sheet text-ink border border-ink-hair rounded-lg ${className}`}
      {...rest}
    >
      {(no !== undefined || title) && (
        <header className="flex items-baseline justify-between gap-4 px-6 sm:px-8 pt-pitch">
          {title ? (
            <h2 className="font-sans font-semibold text-xl leading-pitch text-ink text-balance">
              {title}
            </h2>
          ) : (
            <span />
          )}
          {no !== undefined && <ReceiptNo n={no} />}
        </header>
      )}
      <div className={`px-6 sm:px-8 ${bodyClassName}`}>{children}</div>
    </Tag>
  )
}

Sheet.propTypes = {
  as: PropTypes.elementType,
  no: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  title: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  bodyClassName: PropTypes.string,
  // No longer draws anything; kept so existing callers need no change.
  ruled: PropTypes.bool,
}
